export const SET_DATA_PRIVACY = 'SET_DATA_PRIVACY';

export default {
    SET_DATA_PRIVACY
};
